import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Robot, List, X, TreeStructure } from '@phosphor-icons/react';

const Header = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const scrollToConfigurator = () => {
    setMenuOpen(false);
    navigate('/');
    setTimeout(() => {
      const configurator = document.getElementById('memory-configurator');
      if (configurator) {
        configurator.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  const handleNav = (path) => {
    setMenuOpen(false);
    navigate(path);
  };

  return (
    <header className="backdrop-blur-xl bg-black/70 border-b border-cyan-500/30 sticky top-0 z-50 shadow-lg shadow-cyan-500/20">
      <div className="max-w-7xl mx-auto px-3 py-3">
        {/* Mobile: Simple row with hamburger */}
        <div className="flex items-center justify-between md:hidden">
          <button 
            onClick={scrollToConfigurator}
            className="text-cyan-400 font-['JetBrains_Mono'] font-bold text-sm"
          >
            ServerMemoryRFQ
          </button>
          <button 
            onClick={() => setMenuOpen(!menuOpen)}
            className="text-cyan-400 p-2"
          >
            {menuOpen ? <X size={24} /> : <List size={24} />}
          </button>
        </div>

        {/* Mobile dropdown menu */}
        {menuOpen && (
          <div className="md:hidden mt-3 flex flex-col gap-2">
            <button 
              onClick={scrollToConfigurator}
              className="aqua-button text-white font-['JetBrains_Mono'] font-semibold py-2 text-sm w-full"
            >
              Configurator
            </button>
            <button 
              onClick={() => handleNav('/inventory')}
              className="aqua-button text-white font-['JetBrains_Mono'] font-semibold py-2 text-sm w-full"
            >
              Inventory
            </button>
            <button 
              onClick={() => handleNav('/news')}
              className="aqua-button text-white font-['JetBrains_Mono'] font-semibold py-2 text-sm w-full"
            >
              News
            </button>
            <button 
              onClick={() => handleNav('/rfq')}
              className="aqua-button-primary text-white font-['JetBrains_Mono'] font-bold py-2 text-sm w-full"
            >
              Request Quote
            </button>
            <button 
              onClick={() => handleNav('/agents')}
              className="aqua-button text-white font-['JetBrains_Mono'] font-semibold py-2 text-sm w-full flex items-center justify-center gap-2"
            >
              <Robot size={16} weight="fill" />
              Web3 Agents
            </button>
            <Link
              to="/sitemap"
              onClick={() => setMenuOpen(false)}
              className="aqua-button text-white font-['JetBrains_Mono'] font-semibold py-2 text-sm w-full flex items-center justify-center gap-2"
              data-testid="mobile-nav-sitemap"
            >
              <TreeStructure size={16} weight="fill" />
              Site Map
            </Link>
            <button 
              onClick={() => handleNav('/admin/login')}
              className="aqua-button-ghost text-cyan-400 font-['JetBrains_Mono'] py-2 text-sm w-full border border-cyan-500/50"
            >
              Admin
            </button>
          </div>
        )}

        {/* Desktop: Full navigation */}
        <nav className="hidden md:flex items-center justify-center gap-3">
          <button 
            onClick={scrollToConfigurator}
            className="aqua-button text-white font-['JetBrains_Mono'] font-semibold px-6 py-2.5 text-sm"
            data-testid="nav-configurator"
          >
            Configurator
          </button>
          <button 
            onClick={() => navigate('/inventory')}
            className="aqua-button text-white font-['JetBrains_Mono'] font-semibold px-6 py-2.5 text-sm"
            data-testid="nav-inventory"
          >
            Inventory
          </button>
          <button 
            onClick={() => navigate('/news')}
            className="aqua-button text-white font-['JetBrains_Mono'] font-semibold px-6 py-2.5 text-sm"
            data-testid="nav-news"
          >
            News
          </button>
          <button 
            onClick={() => navigate('/rfq')}
            className="aqua-button-primary text-white font-['JetBrains_Mono'] font-bold px-8 py-3 text-sm"
            data-testid="nav-rfq"
          >
            Request Quote
          </button>
          <button 
            onClick={() => navigate('/agents')}
            className="aqua-button text-white font-['JetBrains_Mono'] font-semibold px-6 py-2.5 text-sm flex items-center gap-1"
            data-testid="nav-agents"
          >
            <Robot size={16} weight="fill" />
            Web3
          </button>
          <Link
            to="/sitemap"
            className="aqua-button text-white font-['JetBrains_Mono'] font-semibold px-6 py-2.5 text-sm flex items-center gap-1"
            data-testid="nav-sitemap"
          >
            <TreeStructure size={16} weight="fill" />
            Site Map
          </Link>
          <button 
            onClick={() => navigate('/admin/login')}
            className="aqua-button-ghost text-cyan-400 font-['JetBrains_Mono'] px-5 py-2.5 text-sm border border-cyan-500/50"
            data-testid="nav-admin"
          >
            Admin
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
